import { useLocalData } from '@support/json';
import { REGION_MODE } from '@support/utils';
import { getSiteRedirect } from '@support/api';

const { siteList } = useLocalData();

const getSiteRedirectData = async () => {
  const { data }: any = await getSiteRedirect();
  return data;
};

export default defineNuxtRouteMiddleware(async (to, from) => {
  // 欧洲站点首页的时候 请求后端，拿到当前ip 地址对应的国家
  let IPData: any = {};
  let defaultPrefixRoute: string = REGION_MODE == 'cn' ? 'cn-zh' : 'us-en';

  let fromLang = '',
    fromCountry = '',
    toLang = '',
    toCountry = '';

  const fromArr = from.path.split('/');

  if (fromArr.length > 1) {
    const tmp = fromArr[1].split('-');

    if (tmp.length > 1) {
      const [first, ...remain] = tmp;
      fromCountry = first?.toLocaleLowerCase() || '';
      fromLang = remain.join('-')?.toLocaleLowerCase() || '';
    }
  }
  const toArr = to.path.split('/');
  if (toArr.length > 1) {
    const tmp = toArr[1].split('-');
    if (tmp.length > 1) {
      const [first, ...remain] = tmp;
      toCountry = first?.toLocaleLowerCase() || '';
      toLang = remain.join('-')?.toLocaleLowerCase() || '';
    }
  }

  const countryList = siteList.map((item: any) => item.country);
  const countryListMap = siteList.map(
    (item: any) => item.country + '-' + item.lang
  );
  const flag = countryListMap.some((v: any) =>
    new RegExp('^/' + v + '(/?$)').test(to.path)
  );
  if (REGION_MODE === 'us' && flag) {
    if (process.client) {
      try {
        IPData = await getSiteRedirectData();
        defaultPrefixRoute = `${IPData.country}-${IPData.language}`;
        let accordValue = false;
        if (toCountry == IPData.country && toLang == IPData.language) {
          accordValue = false;
        } else {
          accordValue = true;
        }
        localStorage.setItem(
          'accord_value_pc',
          JSON.stringify({
            show: accordValue
          })
        );
      } catch (error) {
        console.log('err', error);
      }
      // if (to.path.includes(`/${defaultPrefixRoute}`)) return;
      // return navigateTo(`/${defaultPrefixRoute}/`, {
      //   external: true
      // });
      const cookies = useCookie('invoke');
      const cookiesValue = cookies.value;
      if (cookiesValue?.invokeValue) {
        cookies.value = null;
        return navigateTo(`/${defaultPrefixRoute}/`, {
          external: true
        });
      }
    }
  }

  if (
    (toCountry.length && !countryList.includes(toCountry as string)) ||
    (fromCountry.length && !countryList.includes(fromCountry as string))
  ) {
    // const defaultPrefixRoute = REGION_MODE == 'cn' ? 'cn-zh' : 'us-en';
    if (to.path == `/${defaultPrefixRoute}/404`) return;
    return navigateTo({
      path: `/${defaultPrefixRoute}/404`,
      replace: true
    });
  }

  // 路由中包括语言和国家不单独处理，如果路由中没有国家和语言字段，默认跳转到/us-en/路由下。如果没有countryList对应的国家跳转到404
  // 如果from包括语言和国家，to没有，路由一级目录下加语言和国家
  // TO不包括国家和语言
  if (toCountry == '' && toLang == '') {
    // from中包括国家和语言
    if (fromCountry && fromLang) {
      return navigateTo({
        path: `/${fromCountry}-${fromLang}${to.path}`,
        query: to.query
      });
    } else if (fromCountry == '' && fromLang == '') {
      // const defaultPrefixRoute = REGION_MODE == 'cn' ? 'cn-zh' : 'us-en';
      const cookies = useCookie('invoke');
      cookies.value = JSON.stringify({
        invokeValue: true
      });
      return navigateTo({
        path: `/${defaultPrefixRoute}${to.path}`,
        query: to.query
      });
    }
  }

  const error = useError();
  if (error.value) {
    if (error.value.statusCode === 404) {
      if (toCountry && toLang) {
        return navigateTo(`/${toCountry}-${toLang}/404`, { external: true });
      }
    }
  }
  if (process.client) {
    // 修复路由跳转之后页面滑动位置不变的bug
    document.getElementsByClassName('main')[0]?.scrollTo(0, 0);
  }
});
